module.exports = __webpack_public_path__ + "static/media/3. Leny.389da115.png";